import type React from 'react';
import { useCallback, useState } from 'react';

import type { TextFieldProps } from '@coursera/cds-core';

type Props = {
  email: string;
  errorState: boolean;
  onLink: (email: string) => void;
};

type PropsFromUseSLackAccountLinkingForm = {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
} & Pick<TextFieldProps, 'onChange' | 'value' | 'validationLabel' | 'validationStatus'>;

export const useSlackAccountLinkingForm = ({
  email: emailFromCaller,
  onLink,
}: Props): PropsFromUseSLackAccountLinkingForm => {
  const [email, setEmail] = useState<string>(emailFromCaller);

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
    const newEmail = event.target.value;
    setEmail(newEmail);
  }, []);

  const onSubmit: React.FormEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault();
      onLink(email);
    },
    [onLink, email]
  );

  return {
    onSubmit,
    onChange,
    value: email,
  };
};
